var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4356 16.4249L10.7868 17.2143C10.9999 17.6938 11.4755 18.0028 12.0003 18.0026V18.0026C12.525 18.0028 13.0006 17.6938 13.2138 17.2143L13.5649 16.4249C13.6891 16.1437 13.8992 15.909 14.1652 15.7547V15.7547C14.4317 15.6003 14.7404 15.5348 15.0466 15.5676L15.9059 15.6576C16.4302 15.7164 16.9394 15.4586 17.2025 15.0013V15.0013C17.4649 14.5468 17.4351 13.9803 17.1264 13.5557L16.6182 12.8555C16.4359 12.6074 16.3368 12.308 16.3351 12.0001V12.0001C16.3352 11.692 16.433 11.3919 16.6142 11.1427L17.1224 10.4425C17.4315 10.0192 17.4629 9.45371 17.2025 8.99885V8.99885C16.9404 8.54409 16.4348 8.28675 15.9129 8.34258L15.0546 8.43261C14.748 8.46553 14.439 8.40001 14.1722 8.24554V8.24554C13.9063 8.09122 13.6961 7.85654 13.5719 7.57526L13.2208 6.78593C13.0066 6.30408 12.5276 5.99466 12.0003 5.99758V5.99758C11.4755 5.99744 10.9999 6.30641 10.7868 6.78593L10.4356 7.57526C10.3115 7.85654 10.1013 8.09122 9.83538 8.24554V8.24554C9.56859 8.40001 9.25954 8.46553 8.95302 8.43261L8.09466 8.34258C7.57039 8.28384 7.0612 8.54158 6.79812 8.99885V8.99885C6.53566 9.45343 6.56546 10.0199 6.87415 10.4445L7.38236 11.1447C7.56464 11.3928 7.66374 11.6922 7.66548 12.0001V12.0001C7.66532 12.3082 7.56761 12.6083 7.38636 12.8575L6.87815 13.5577C6.56905 13.981 6.5377 14.5465 6.79812 15.0013V15.0013C7.06014 15.4561 7.56579 15.7134 8.08766 15.6576L8.94701 15.5676C9.25321 15.5348 9.5619 15.6003 9.82838 15.7547V15.7547C10.0969 15.9078 10.3096 16.1426 10.4356 16.4249Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 12.0003,
    r: 9.00375,
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 12.0001,
    r: 1.50063,
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.9fa98180d205e56eb6ba1c47c6ce13e2.svg";
export { ForwardRef as ReactComponent };